import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CallsAnalyticsPageStore } from 'pages/analytics/pages/calls/store/callsAnalyticsPageStore'

const CallsAnalyticsPageContext = createContext<CallsAnalyticsPageStore | null>(null)

export const useCallsAnalyticsPageContext = () => {
  const context = useContext(CallsAnalyticsPageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with CallsAnalyticsPageProvider'
    )

  return context
}

export const CallsAnalyticsPageProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new CallsAnalyticsPageStore(entities), [])

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <CallsAnalyticsPageContext.Provider value={store}>
      {children}
    </CallsAnalyticsPageContext.Provider>
  )
}
